/**
 * HHMM 형태의 시각(예: "1100", 900, "0900")을 "11:00"으로 바꾼다.
 * 서버가 시각을 숫자(bigint)로 저장하므로 9시는 900처럼 3자리로 올 수 있어, 앞을 0으로 채운 뒤 나눈다.
 * 값이 없거나 숫자 1~4자리가 아니면 빈 문자열을 돌려준다.
 */
export const formatHHMM = (value: string | number | null | undefined): string => {
  if (value == null) return '';
  const digits = String(value).trim();
  if (!/^\d{1,4}$/.test(digits)) return '';
  const padded = digits.padStart(4, '0');
  return `${padded.slice(0, 2)}:${padded.slice(2)}`;
};

/**
 * 체크인 날짜("YYYY-MM-DD")가 오늘(한국 시간)보다 이전이면 true.
 * 체크인이 지난(숙박 중이거나 숙박을 마친) 예약은 서버가 고객 취소를 거절하므로 취소 버튼을 보여주지 않는 데 쓴다.
 * 체크인 당일은 false(환불 규정대로 취소 가능).
 */
export const isCheckInPassed = (checkIn: string | null | undefined): boolean => {
  if (!checkIn) return false;
  const todayInKorea = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Seoul' }).format(new Date());
  return checkIn.slice(0, 10) < todayInKorea;
};
